import type { Locale } from './config';

/**
 * Per-page copy for the translated marketing pages. Each page keeps its own
 * file under `src/lib/i18n/pages/<page>.ts` exporting `{ en, ar, ckb }` with
 * an identical key shape, so pages can be translated independently.
 *
 *   const t = pageCopy(contactCopy, locale);
 *
 * Falls back to English if a locale is somehow missing.
 */
export interface PageCopy<T> {
  en: T;
  ar: T;
  ckb: T;
}

export function pageCopy<T>(copy: PageCopy<T>, locale: Locale): T {
  return copy[locale] ?? copy.en;
}

/**
 * Compile-time guard: pass the English object to fix the shape, and both
 * translations must match it key for key.
 *
 *   export const contactCopy = defineCopy(en, ar, ckb);
 */
export function defineCopy<T>(en: T, ar: T, ckb: T): PageCopy<T> {
  return { en, ar, ckb };
}
